import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { QuoteEmailAddRecFileModalNavigationState } from 'src/app/models/quote/quote-email-add-rec-file-modal-navigation-state';

@Component({
  selector: 'app-quote-email-add-rec-file-modal',
  templateUrl: './quote-email-add-rec-file-modal.page.html',
  styleUrls: ['./quote-email-add-rec-file-modal.page.scss'],
})
export class QuoteEmailAddRecFileModalPage implements OnInit {

  navigationState: QuoteEmailAddRecFileModalNavigationState;
  canExit: boolean;
  filesSizeValid: boolean = true;
  selectedFilesSize: number = 0;
  recommendationFiles: any;
  maximumEmailAttachmentSize: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navController: NavController,
  ) { }

  ngOnInit() {
    this.navigationState = <QuoteEmailAddRecFileModalNavigationState>this.router.getCurrentNavigation()?.extras.state;
    if (!this.navigationState) {
      this.navController.navigateRoot(['']);
      return;
    }
    this.recommendationFiles = this.navigationState.recommendationFiles;
    this.maximumEmailAttachmentSize = this.navigationState.maximumEmailAttachmentSize;

    this.updateSelectedFilesSize();
  }

  confirmAddRecommendationFiles() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }

  toggleSelectFileForAttachment(file) {
    if (file.fileSizeKb <= this.maximumEmailAttachmentSize) {
      this.updateSelectedFilesSize();
    }
  }

  updateSelectedFilesSize() {
    this.selectedFilesSize = 0;

    this.recommendationFiles.filter((file) => file.selectedForEmailAttachment == true).forEach((file) => this.selectedFilesSize += file.fileSizeKb);
    this.filesSizeValid = this.selectedFilesSize <= this.maximumEmailAttachmentSize;
  }
}
